module.exports = __webpack_public_path__ + "static/img/temp.a1d24296.svg";